<template>
  <div class="club_page">
    <ClubHeader>
      <template v-slot:club-header-title>
        <h2 class="mar10t">باشگاه مشتریان</h2>
      </template>
    </ClubHeader>
    <div class="club-box">
      <div class="custom-box">
        <h2 class="textCenter mar5b">
          امتیاز شما:<span class="primary-color mar5r">{{
          infoItems.score | persian
          }}</span>
        </h2>
        <img src="../../assets/img/diamond.png" alt="score-diamond" class="dBlock marAuto" />
      </div>
      <ClubFooter></ClubFooter>
      <div v-for="item in list" v-bind:key="item.id">
        <a :href="`/Detail/${item.id}?token=${getToken}`">
          <ClubContainer class="mar10t" type="ticket-bg" :style="[
            item.imageUrl
              ? {
                  background:
                    'linear-gradient(to top, rgb(28, 95, 168), rgba(43, 102, 155, 0.7), rgba(0, 92, 147, 0.2), rgba(211, 210, 232, 0), rgb(255, 255, 255)), url(' +
                    item.imageUrl +
                    ') no-repeat center center / cover',
                }
              : {
                  background: '#002664',
                },
          ]">
            <template v-slot:ticket-right>
              <div v-if="item.iconUrl">
                <img :src="item.iconUrl" alt="" class="position-absolute" width="50px" style="top: 10px;" />
              </div>
              <div v-else>
                <img src="../../assets/img/logo-new.svg" alt="" class="position-absolute"
                  style="top: 10px; width: 35px;" />
              </div>
              <div class="dFlex">
                <p class="mar5t text-white font-bold">
                  فقط {{ item.score | persian }} امتیاز
                </p>
                <!-- <i
                  class="fas fa-shopping-cart mar10r primary-color"
                  @click="ScoreArray(item.Score)"
                ></i> -->
              </div>
              <!-- <p style="font-size: 10px">امتیاز مورد نیاز</p> -->
              <a class="view-btn">خرید</a>
            </template>
            <template v-slot:ticket-left>
              <div class="bonus-content">
                <!-- <p class="font-bold bonus-title">
                  {{ item.title | persian }}
                </p> -->

                <div class="primary-btn pad5 w-max-content b-radiuse20">
                  <a href="#" class="text-decoration-none text-white font12">تخفیف ویژه کاربران</a>
                </div>
                <p class="text-white p-absolute mb-0" style="bottom: 10px;">
                  {{ item.title | persian }}
                </p>
              </div>
            </template>
          </ClubContainer>
        </a>
      </div>
    </div>
    <div class="error-message textCenter" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="success-message textCenter" v-if="successMessage">
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import ClubHeader from '../../components/Club/Header.vue'
import ClubContainer from '../../components/Club/ScoreContainer.vue'
import api from '../../service'
import ClubFooter from '../../components/Club/ClubFooter.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ClubHeader,
    ClubContainer,
    ClubFooter,
  },
  data() {
    return {
      errorMessage: false,
      successMessage: false,
      hasToken: false,
      infoItems: [],
      list: [],
      score: [],
    }
  },
  computed: {
    ...mapGetters(['getToken']),
  },
  mounted: function () {
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token)
    }
    if (this.$route.query.token) {
      this.$ga.event('club', 'clicked', 'باشگاه')

      api
        .getInfoUserBonus()
        .then((response) => {
          // debugger;
          if (response.data && response.status === 200) {
            this.infoItems = response.data.data.info
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0]
            }
          }
        })
        .catch(() => {
          this.errorMessage = 'متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.'
        })
        .finally(() => {
          this.loading = false
        })
      api
        .getAllActiveBonus()
        .then((response) => {
          if (response.data && response.status === 200) {
            var bonusArray = response.data.data
            for (var i = 0; i < bonusArray.length; i++) {
              var x = bonusArray[i].score
              bonusArray[i].score = x.toString().replace(/-/g, '')
            }
            this.list = bonusArray
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0]
            }
          }
        })
        .catch(() => {
          this.errorMessage = 'متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.'
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    ...mapActions(['setTheme', 'setToken']),
  },
}
</script>
<style scoped>
.view-btn {
  width: 60px;
  background: #f2f2f2;
  padding: 2px 5px;
  border-radius: 5px;
  text-align: center;
  margin: 10px auto 0 auto;
  display: block;
}

.view-btn:hover {
  color: #002664;
}

.right-side a>div {
  font-size: 22px;
}

.custom-box {
  background: #fff;
  border-bottom: 10px solid #002664;
  margin: -50px 0px 20px;
}

.custom-box img {
  width: 50px;
}

a {
  color: #000;
}

.ticket>div:first-child {
  width: 30%;
}

.ticket>div:last-child {
  width: 70%;
}

@media all and (max-width: 760px) {
  .club-footer {
    width: 100%;
  }
}
</style>
